import { lazy } from 'react'
import './sidemenu.requests'

const Sidemenu = lazy(() => import('./sidemenu.component'))

import * as SidemenuContext from './sidemenu.context'

export { Sidemenu, SidemenuContext }
